export default context => {
    try {
        let req = require.context("../doc-ready", true, /^.*\.(js)$/);
        req.keys().forEach(f => req(f).default(context));
    } catch (e) {
        console.debug(e)
        throw e
    }
}
